import { ActivatedRouteSnapshot, Data } from '@angular/router';

export function getLastActivatedRouteSnapshotData(route: ActivatedRouteSnapshot): Data {
  let lastChild = route;
  while (lastChild.firstChild) {
    lastChild = lastChild.firstChild;
  }

  return lastChild.data;
}
